define('widgets/olark/olark',[
    'knockout',
    'underscore',
    'jquery',
    'common/tools',
    'common/clientSniffer',
    'common/async'
], function (ko, _, $, tools, client, async) {

    /**
     * @param {common/Session} session
     * @param {WP} olarkTranslationPage
     * @param {Function} openChat
     * @param {Observable} isUserBanished
     * @param {Boolean} isEnabled
     * @param {String} olarkIdentity
     */
     /* eslint-disable max-statements, max-params, vars-on-top, func-style */
    function Olark (
        session,
        olarkTranslationPage,
        openChat,
        isUserBanished,
        isEnabled,
        olarkLoginModel,
        formFields,
        olarkSpecificSession,
        olarkStorage,
        olarkOperator,
        olarkCode,
        olarkIdentity
    ) {
        var self = this,
            statusVoca = ko.observable('OLARK_WELCOME_TITLE'),
            conversationStarted = ko.observable(false);

        self.isEnabled = isEnabled;
        self.email = ko.observable();
        self.name  = ko.observable();
        self.olarkReady = ko.observable(false);
        self.olarkMessages = ko.observableArray();

        self.startConversation = function (email, name) {
            self.populatePrechatSurvey({
                name: name,
                email: email
            });
            $('#habla_pre_chat_name_input').click();
            $('#habla_pre_chat_email_input').click();
            $('#habla_pre_chat_submit_input').trigger('click');
            $('.olark-login').hide();
            $('#habla_pre_chat_div').hide();
            $('#habla_window_div').show();
        };

        self.olarkStatusText = ko.deferredComputed({
            read: function () {

                if (conversationStarted()) {
                    return 'OLARK_CHATTING_TITLE';
                }

                return statusVoca();
            },
            write: function (value) {
                statusVoca(value);
            }
        });

        self.emailField = formFields.emailField(olarkLoginModel.email);
        self.loginIDField  = formFields.textField(olarkLoginModel.name.firstName);
        self.initialize = function () {

            if (!isEnabled) {
                return;
            }

            olarkCode();

            var olark = window.olark,
                translations = olarkTranslationPage('translations')(),
                actionsApplied = true,
                notifyOperator = function (message) {
                    olark('api.chat.sendNotificationToOperator', {
                        body: message
                    });
                },
                getSupportDetails = function () {
                    return client.features().join('; ');
                },
                getSenseiLink = function (id) {
                    var link = 'BEWARE: The player is not logged in yet. ' +
                        'Proactive chat or Sensei shortcut are not available.';

                    if (id) {
                        link = _.str.sprintf(
                            'http://sensei.casumo.com/#!/player/show/%s/overview',
                            id
                        );
                    }

                    return link;
                },
                banishUser = function (banish) {

                    isUserBanished(!!banish);

                    if (banish) {
                        $('.help').find('textarea, :submit').remove();
                    } else {
                        document.location.reload(true);
                    }

                },
                getDetailsFromOlark = function () {
                    var deferred = async.defer();

                    olark('api.visitor.getDetails', function (details) {
                        deferred.resolve(details);
                    });
                    return deferred.promise();
                },
                showOlarkLogin = function () {
                    $('#habla_pre_chat_div').hide();
                    $('.olark-login').show();
                    $('#habla_window_div').hide();
                },
                populateOlarkLogin = function (cb) {
                    getDetailsFromOlark().then(function (details) {
                        if (details && details.emailAddress && details.fullName) {
                            self.email(details.emailAddress);
                            self.name(details.fullName);
                            if ($('#habla_chatform_form').css('display') === 'block') {
                                $('.olark-login').hide();
                            } else {
                                $('#habla_window_div').hide();
                            }
                            if (details.isConversing) {
                                self.startConversation(
                                    details.emailAddress,
                                    details.fullName
                                );
                            }
                            cb();
                        } else {
                            showOlarkLogin();
                        }
                    });
                },
                updateVisitorNickname = function (nickname) {
                    olark('api.chat.updateVisitorNickname', {
                        snippet: nickname,
                        hidesDefault: true
                    });
                },
                enableOfflineStatus = function () {
                    getDetailsFromOlark().then(function (details) {
                        if (
                            details &&
                            details.emailAddress &&
                            details.fullName &&
                            details.customFields.casumoName
                        ) {
                            updateVisitorNickname(
                                _.str.sprintf(
                                    '%s - Not logged - %s',
                                    details.fullName,
                                    details.customFields.casumoName
                                )
                            );
                            self.populatePrechatSurvey({
                                name: details.fullName,
                                email: details.emailAddress
                            });
                        }
                    });
                },
                replacePreChatQuery = function () {
                    getDetailsFromOlark().then(function (details) {
                        if (details && details.emailAddress && details.fullName) {
                            self.populatePrechatSurvey({
                                name: details.fullName,
                                email: details.emailAddress
                            });
                            $('#habla_pre_chat_submit_input').trigger('click');
                        }
                    });
                },
                enableProactiveChat = function (playerIsLogged) {
                    var notifyOlark = function (username) {

                        if (_.isEmpty(username)) {
                            return;
                        }

                        olark('api.visitor.updateFullName', {
                            fullName: olarkSpecificSession().fullName
                        });

                        olark('api.visitor.updatePhoneNumber', {
                            phoneNumber: olarkSpecificSession().phoneNumber
                        });

                        olark('api.visitor.updateEmailAddress', {
                            emailAddress: olarkSpecificSession().email
                        });

                        olark('api.visitor.updateCustomFields', {
                            casumoName: username
                        });

                        updateVisitorNickname(
                            _.str.sprintf(
                                '%s - logged as %s (%s)',
                                olarkSpecificSession().fullName,
                                olarkSpecificSession().username,
                                olarkSpecificSession().email
                            )
                        );

                        self.populatePrechatSurvey({
                            name: olarkSpecificSession().fullName,
                            email: olarkSpecificSession().email
                        });
                    };

                    if (!playerIsLogged) {
                        return enableOfflineStatus();
                    }

                    olarkSpecificSession().username.subscribe(notifyOlark);
                    notifyOlark(olarkSpecificSession().username());
                };

            self.populatePrechatSurvey = function (credentials) {
                $('#habla_pre_chat_name_input').focus().val(credentials.name);
                $('#habla_pre_chat_email_input').focus().val(credentials.email);
            };

            olark.configure('system.is_single_page_application', true);
            olark.configure('box.inline', true);
            olark.configure('features.feedback', false);

            // Translating Olark strings with cms values
            _.each(translations, function (translation) {
                olark.configure(
                    'locale.' + translation.key.toLowerCase(),
                    _.unescape(translation.value)
                );
            });

            olark.identify(olarkIdentity);

            function placeSendMessageButton () {
                $('<span class="icons-send icon olark-send"></span>')
                    .insertAfter('#habla_chatform_form .hbl_txt_wrapper');

                $('#habla_wcsend_input').keyup(function () {
                    if (this.value.length) {
                        $('.olark-send').addClass('olark-send-active');
                    } else {
                        $('.olark-send').removeClass('olark-send-active');
                    }
                });

                applyDeviceSpecificActions();

                $('.olark-send').click(function () {
                    $('#habla_chatform_form').submit();
                    scrollToBottom();
                });
            }

            function applyDeviceSpecificActions () {
                if (client.device.type === 'tablet') {
                    adjustOlarkOnTablet();
                } else if (client.device.model === 'iPhone') {
                    adjustOlarkOnMobile();
                }
            }

            $(window).resize(function () {
                var t = setTimeout(applyDeviceSpecificActions);

                clearTimeout(t);
            });

            function adjustOlarkOnTablet () {
                $('#habla_wcsend_input').focus(function () {
                    var t = setTimeout(function () {
                        $('.pages-container').stop().animate({
                            top: window.pageYOffset
                        }, 0);
                        clearTimeout(t);
                    }, 500);
                }).blur(function () {
                    var t = setTimeout(function () {
                        $('.pages-container').stop().animate({
                            top: -window.pageYOffset
                        }, 0);
                        clearTimeout(t);
                    }, 500);
                });
            }

            function adjustOlarkOnMobile () {
                var defaultHeight = document.body.style.height;

                if (actionsApplied) {
                    actionsApplied = false;

                    $('#habla_chatform_form')[0]
                        .addEventListener('touchmove', function (e) {
                            e.preventDefault();
                        }, false);

                    $('#habla_wcsend_input').focus(function () {
                        $('body').css('height', 'calc(100% + 10px)')
                            .css('margin-bottom', '-10px');

                        $(document).on('touchmove', '#habla_conversation_div', function (e) {
                            e.stopPropagation();
                        });
                    }).blur(function () {
                        $('body').css('height', defaultHeight).css('margin-bottom', 0);
                    });
                }
            }

            function scrollToBottom () {
                setTimeout(function () {
                    $('#habla_middle_wrapper_div').stop().animate({
                        scrollTop: 1000000
                    }, 200);
                }, 200);
            }

            // Events
            olark('api.box.onShow', function () {
                self.olarkReady(true);
                $('.chat-loader').remove();
                $('#habla_middle_wrapper_div, #habla_wcsend_input').addClass('scroll-y');
                placeSendMessageButton();

                // @todo check this
                populateOlarkLogin(setTimeout(olarkOperator.init));
            });

            olark('api.chat.updateVisitorStatus', {
                snippet: client.features()
            });
            olark('api.chat.onMessageToOperator', function () {
                setTimeout(olarkOperator.init());
                scrollToBottom();
                conversationStarted.bind(self, true);
            });

            olark('api.chat.onMessageToVisitor', function (details) {
                if (!conversationStarted()) {
                    replacePreChatQuery();
                    conversationStarted(true);
                }
                openChat();
                setTimeout(olarkOperator.appendStylesForNewMessage(details.message.nickname));
                scrollToBottom();
            });
            olark('api.chat.onCommandFromOperator', function (event) {
                switch (event.command.name) {
                    case 'info':
                        notifyOperator(getSupportDetails());
                        break;
                    case 'goto':
                        notifyOperator(
                            getSenseiLink(session.id())
                        );
                        break;
                    case 'ban':
                        banishUser(true);
                        break;
                    case 'forgive':
                        banishUser(false);
                        break;
                }
            });
            olark('api.chat.onBeginConversation', function () {
                notifyOperator(getSenseiLink(session.id()));
            });

            session.loggedIn.subscribe(enableProactiveChat);
            enableProactiveChat(session.loggedIn());

            self.olark = olark;

            _.delay(function () {
                if (isUserBanished()) {
                    banishUser(true);
                }
            }, 3000);

            // Fix the scrolling when the conversation div is visible
            new tools.WhenVisibleTrigger('#habla_conversation_div', function () {
                ko.applyBindingsToNode(
                    document.getElementById('habla_conversation_div'), {
                        scrollTrap: {
                            alwaysStopPropagation: true
                        }
                    }
                );
            }).trigger();
        };
    }

    return Olark;

});

